<template>
  <!-- 商务合作 -->
  <div id="business" class="section business animate__animated together init--zzQhF">
    <div class="business_box maxWidth">
      <div class="business_title size_center">
        <div>商务合作</div>
        <div></div>
      </div>
      <!-- 新ui -->
      <div class="business_main">
        <!-- <div class="business_nav">
          <div class="business_nav_1">商务合作</div>
          <div class="business_nav_2">千年引擎盒子</div>
        </div> -->
        <div class="new_left">
          <div class="business_nav_1">商务合作</div>
          <div class="new_left_1">
            <div class="business_icon2 new_left_1_icon"></div>
            <div class="new_left_1_text">邮箱</div>
            <div class="new_left_1_mailbox">{{businessEmail}}</div>
          </div>
          <div class="business_nav_1">微信公众号</div>
          <div class="new_left_2">
            <div class="new_left_2-icon"></div>
          </div>
        </div>
        <div class="new_right">
          <div class="new_right_title">千年引擎合作</div>
          <div class="new_right—box">
            <!-- :style="{ border: index == 3 ? 'none' : '' }" -->
            <div :class="[{ 'no-border-right': (index + 1) % 3 == 0 }]" v-for="(item, index) in list" :key="index">
              <div class="li_name">{{ item.name }}</div>
              <div class="li-flex">
                <div v-if="item.qq" class="business_icon2 li-icon"></div>
                <div class="li-text">{{ item.qq }}</div>
              </div>
              <div v-if="item.phone" class="li-flex jg">
                <div class="business_icon0 li-icon"></div>
                <div class="li-text">{{ item.phone }}</div>
              </div>
              <div v-if="item.mailbox" class="li-flex">
                <div class="business_icon1 li-icon"></div>
                <div class="li-text">{{ item.mailbox }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { businessEmail, businessList } from "@/utils/commonData";
export default {
  data() {
    return {
      businessEmail,
      list: businessList,
    };
  },
  created() { },
  mounted() { },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.business {
  height: 15.175rem
    /* 1214/80 */
  ;
  height: 11.25rem
    /* 900/80 */
  ;
  background: #1c1c1c;
}

.business_box {
  height: 100%;
  background: url("../../assets/images/pc/business.jpg") no-repeat center;
  background-size: cover;
}

.business_title div:nth-child(1) {
  font-size: 0.45rem
    /* 36/80 */
  ;
  color: #fff;
  padding-top: 0.775rem
    /* 62/80 */
  ;
  margin-bottom: 0.3125rem
    /* 25/80 */
  ;
  font-weight: 700;
}

.business_title div:nth-child(2) {
  width: 10.875rem
    /* 870/80 */
  ;
  height: 1px;
  margin: 0 auto;
  background: linear-gradient(to right, #1f1f1f, #9c9c9c 50%, #1f1f1f);
}

.business_main {
  width: 15.275rem
    /* 1222/80 */
  ;
  margin: 0 auto;
  margin-top: 1.5125rem
    /* 121/80 */
  ;
  position: relative;
  height: 9.2rem
    /* 736/80 */
  ;
  // 新布局
  height: 5.8625rem
    /* 469/80 */
  ;
  background: #fff;
  display: flex;

  .business_nav_1 {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(61, 61, 61);
    color: #fff;
    font-size: 0.225rem
      /* 18/80 */
    ;
    height: 0.65rem
      /* 52/80 */
    ;
  }

  .new_left {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 2.9875rem
      /* 239/80 */
    ;
    border-right: 1px solid #e4e7eb;

    .new_left_1 {
      height: 1.95rem
        /* 156/80 */
      ;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-sizing: border-box;

      .new_left_1_icon {
        width: 0.425rem
          /* 34/80 */
        ;
        height: 0.425rem
          /* 34/80 */
        ;
        background: #3d3d3d;
        border-radius: 50%;
        background-size: cover;
      }

      .new_left_1_text {
        font-size: 0.175rem
          /* 14/80 */
        ;
        color: #2c3e50;
        padding-top: 0.15rem
          /* 12/80 */
        ;
        padding-bottom: 0.125rem
          /* 10/80 */
        ;
      }

      .new_left_1_mailbox {
        font-size: 0.175rem
          /* 14/80 */
        ;
        color: #2c3e50;
      }
    }

    .new_left_2 {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 2.6875rem
        /* 215/80 */
      ;

      .new_left_2-icon {
        width: 1.8875rem
          /* 151/80 */
        ;
        height: 1.8875rem
          /* 151/80 */
        ;
        background: url("../../assets//images//gzh.jpg") no-repeat;
        background-size: cover;
      }
    }
  }

  .new_right {
    flex: 1;
    display: flex;
    flex-direction: column;

    .new_right_title {
      flex-shrink: 0;
      height: 0.65rem
        /* 52/80 */
      ;
      background: #641200;
      font-size: 0.225rem
        /* 18/80 */
      ;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .new_right—box {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      >div {
        border-right: 1px solid #e4e7eb;
        border-bottom: 1px solid #e4e7eb;
        flex: 0 0 calc(100% / 3);
        height: 2.6rem
          /* 208/80 */
        ;
        padding-left: 0.775rem
          /* 62/80 */
        ;
        box-sizing: border-box;
        color: #2c3e50;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .li_name {
          font-size: 0.175rem
            /* 14/80 */
          ;
          font-weight: bold;
          color: #000;
          margin-bottom: 0.125rem
            /* 10/80 */
          ;
          width: 100%;
          box-sizing: border-box;
          padding-left: 0.425rem
            /* 34/80 */
          ;
          // padding-left:.375rem /* 30/80 */;
        }

        .li-flex {
          width: 100%;
          display: flex;
          align-items: center;
        }

        .li-icon {
          width: 0.275rem
            /* 22/80 */
          ;
          height: 0.275rem
            /* 22/80 */
          ;
          background: #a92826;
          border-radius: 50%;
          margin-right: 0.125rem
            /* 10/80 */
          ;
          background-size: cover;
          flex-shrink: 0;
        }

        .li-text {
          font-size: 0.175rem
            /* 14/80 */
          ;
          // flex: 1;
          width: 2.875rem
            /* 230/80 */
          ;
          overflow: hidden;
          /* 超出的文本隐藏 */
          text-overflow: ellipsis;
          /* //溢出用省略号显示 */
          white-space: nowrap;
          /* //溢出不换行 */
        }
      }

      .jg {
        padding-top: 0.15rem
          /* 12/80 */
        ;
        padding-bottom: 0.125rem
          /* 10/80 */
        ;
      }
    }
  }
}

.business_main>div:nth-child(1) {
  position: relative;
}

.business_main .business_main-navMenu {
  display: flex;
  font-size: 0.3rem
    /* 24/80 */
  ;
  background: #0b0b0b;
  position: relative;
  border-radius: 0.1875rem
    /* 15/80 */
  ;
  overflow: hidden;
}

.business_main-navMenu_shadow {
  position: absolute;
  left: 0;
  top: 0;
  background: #707070;
  width: 3.825rem
    /* 306/80 */
  ;
  height: 1rem
    /* 80/80 */
  ;
  padding: 0.3125rem
    /* 25/80 */
    0;
  z-index: 0;
  transition: 500ms cubic-bezier(0.48, 0.33, 0.24, 0.95) 0ms;
  transform: translateX(0);
  border-radius: 0.1875rem
    /* 15/80 */
  ;
}

.business_main-navMenu_shadow::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.28rem;
  width: 0px;
  height: 0px;
  margin: 0 auto;
  border: 0.15rem
    /* 12/80 */
    solid transparent;
  /* 朝下的三角形 */
  border-top-color: #707070;
}

.business_main .business_main-navMenu>div {
  display: flex;
  justify-content: center;
  color: #fff;
  /* width: 300px; */
  flex: 1;
  padding: 0.3125rem
    /* 25/80 */
    0;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

@keyframes axxll {
  0% {
    transform: scale(0);
    background: #707070;
  }

  100% {
    transform: scale(1);
    background: #707070;
  }
}

.business_main .business_main-navMenu>div:nth-child(4) {
  border: none;
}

.business_main .business_main-navMenu>div>div {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 1rem
    /* 80/80 */
  ;
  border-right: 0.0125rem
    /* 1/80 */
    solid #6c6c6c;
}

.business_main .business_main-navMenu>div:nth-child(4)>div {
  border: none;
}

.boderNo {
  border: none !important;
}

.business_main .business_main-navMenu>div .boderNo {
  border: none;
}

.business_main .business_main-navMenu>div .bodertake {
  border-right: 0.0125rem
    /* 1/80 */
    solid #6c6c6c;
}

.business_main-navMenu-margin {
  margin-left: 0.375rem
    /* 30/80 */
  ;
}

.business-img0 {
  width: 0.8375rem
    /* 67/80 */
  ;
  height: 0.825rem
    /* 66/80 */
  ;
  background: url("../../assets/images/pc/business-0.png") no-repeat center;
  background-size: cover;
}

.business-img1 {
  width: 0.775rem
    /* 62/80 */
  ;
  height: 0.6125rem
    /* 49/80 */
  ;
  background: url("../../assets/images/pc/business-1.png") no-repeat center;
  background-size: cover;
}

.business-img2 {
  width: 0.6625rem
    /* 53/80 */
  ;
  height: 0.65rem
    /* 52/80 */
  ;
  background: url("../../assets/images/pc/business-2.png") no-repeat center;
  background-size: cover;
}

.business-img3 {
  width: 0.8875rem
    /* 71/80 */
  ;
  height: 0.675rem
    /* 54/80 */
  ;
  background: url("../../assets/images/pc/business-3.png") no-repeat center;
  background-size: cover;
}

@keyframes business-img_activate {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.business-img01 {
  width: 0.8375rem
    /* 67/80 */
  ;
  height: 0.825rem
    /* 66/80 */
  ;
  background: url("../../assets/images/pc/business-01.png") no-repeat center;
  background-size: cover;
}

.business-img_activate_animation {
  animation: business-img_activate 500ms;
  animation-timing-function: cubic-bezier(0.48, 0.33, 0.24, 0.95);
}

.business-img11 {
  width: 0.775rem
    /* 62/80 */
  ;
  height: 0.6125rem
    /* 49/80 */
  ;
  background: url("../../assets/images/pc/business-11.png") no-repeat center;
  background-size: cover;
}

.business-img21 {
  width: 0.6625rem
    /* 53/80 */
  ;
  height: 0.65rem
    /* 52/80 */
  ;
  background: url("../../assets/images/pc/business-21.png") no-repeat center;
  background-size: cover;
}

.business-img31 {
  width: 0.8875rem
    /* 71/80 */
  ;
  height: 0.675rem
    /* 54/80 */
  ;
  background: url("../../assets/images/pc/business-31.png") no-repeat center;
  background-size: cover;
}

.business_main-info {
  margin-top: 1.125rem
    /* 90/80 */
  ;
  position: relative;
}

.business_main-info>div {
  height: 0;
  position: relative;
  overflow: hidden;
}

.business_main-info .vanish {
  height: 0;
  position: relative;
}

.business_main-info .appear {
  width: 9.8125rem;
  transition: all 0.5s linear;
  height: 6.45rem
    /* 516/80 */
  ;
}

.business_main-info_1-li {
  display: flex;
  color: #fff;
  font-size: 0.25rem
    /* 20/80 */
  ;
  padding: 0.5625rem
    /* 45/80 */
    0;
  /* background: #4e4e4e; */
  margin-bottom: 0.3rem
    /* 24/80 */
  ;
  box-sizing: border-box;
  position: relative;
  border-radius: 0.1875rem
    /* 15/80 */
  ;
  overflow: hidden;
}

.business_main-info_1-li::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background: red; */
  background-image: linear-gradient(to bottom right, #707070, #2c2c2c);
  opacity: 0.27;
}

.business_main-info_1-li div:nth-child(1) {
  width: 0.8375rem
    /* 67/80 */
  ;
  height: 0.8375rem
    /* 67/80 */
  ;
  margin-left: 0.675rem
    /* 54/80 */
  ;
  margin-right: 0.25rem
    /* 20/80 */
  ;
  border-radius: 50%;
  background: #595959;
  position: relative;
  z-index: 1;
  background-size: cover;
}

.business_icon0 {
  background-image: url("../../assets/images/pc/phone.png") !important;
}

.business_icon1 {
  background-image: url("../../assets/images/pc/mailbox.png") !important;
}

.business_icon2 {
  background-image: url("../../assets/images/pc/qq.png") !important;
}

.business_icon3 {
  background-image: url("../../assets/images/pc/wx.png") !important;
}

.business_main-info_1-li div:nth-child(2) {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}

.business_main-info_1-bg {
  position: absolute;
  bottom: 0.475rem
    /* 38/80 */
  ;
  right: 0;
  width: 7.2875rem
    /* 583/80 */
  ;
  height: 5.35rem
    /* 428/80 */
  ;
  background: url("../../assets/images/pc/business-info0.png") no-repeat center;
  background-size: cover;
}
</style>
